import { OrderType, PaymentType } from '@us/web/shared/data-access';

export const ORDER_QRCODE_PREFIX = 'posapp-';

export const DEFAULT_IMAGE = '/assets/icons/picture.svg';

export const PAYMENT_METHODS = [
    PaymentType.Cash,
    PaymentType.ZaloPay,
    PaymentType.BankTransfer,
    PaymentType.Payon,
    PaymentType.Momo,
    PaymentType.Vnpay,
    PaymentType.PosappCard
];

export const ORDER_TYPES = [OrderType.Delivery, OrderType.Pickup, OrderType.TakeAway, OrderType.OrderAtTheTable];

export const PHONE_NUMBER_PATTERN = '^((\\+84-?)|0)[1-9][0-9]{8}$';
export const PHONE_NUMBER_PATTERN_SHORT = '^0[1-9][0-9]{8}$';

export const OTP_LENGTH = 6;

export const INPUT_DEBOUNCE_TIME = 400;

export const LANGUAGES = [
    { key: 'vi', label: 'Tiếng Việt', icon: 'vn' },
    { key: 'en', label: 'English', icon: 'us' },
    { key: 'ja', label: '日本語', icon: 'jp' },
    { key: 'zh-cn', label: '中文', icon: 'zh-cn' }
];

export const DEFAULT_LANGUAGE = 'vi';

export const PROMOTION_TYPE = {
    DISCOUNT_ORDER_TYPE: 1,
    REDUCE_SHIPPING_FEES: 7,
    GIFT_BY_PRODUCT_TYPE: 0,
    DISCOUNT_PRODUCT_TYPE: 2,
    BILL_SURCHARGE: 3,
    FOOD_SURCHARGE: 4,
    DISCOUNT_BY_ORDER_COUNT_TYPE: 5,
    SERVICE_PACK: 6,
    COMBO: 8,
    UPSIZE: 9,
    SAME_PRICE: 10
};
export const PROMOTION_SUBTYPE = {
    // KM giảm theo % hoặc số tiền
    PERCENT: 0,
    MONEY: 1,
    PERCENT_LOW: 2,
    MONEY_LOW: 3
};

export const PROMOTION_SUBTYPE2 = {
    // KM giảm theo % hoặc số tiền
    GIFT_FREE: 0,
    BUY_X_GIFT_Y: 1,
    GIFT_PRODUCT_LOW: 2
};

export const PROMOTION_WEBORDER = 2;
